import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextarea } from 'primeng/inputtextarea';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DataProtectionDetailComponent } from './data-protection-detail/data-protection-detail.component';
import { DataProtectionListComponent } from './data-protection-list/data-protection-list.component';
import { DataProtectionRoutingModule } from './data-protection-routing.module';

import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        DataProtectionDetailComponent,
        DataProtectionListComponent
    ], imports: [CoreModule,
        CommonModule,
        DataProtectionRoutingModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        DropdownModule,
        CalendarModule,
        CheckboxModule,
        ConfirmDialogModule,
        InputTextarea,
        DialogModule,
        TagModule,
        TooltipModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class DataProtectionModule { }